import React from "react";
import RenderExcelUpload from "./RenderExcelUpload";
import { Field } from "redux-form";

const RenderExcelUploadField = (props) => {
  return (
    <div>
      <Field {...props} component={RenderExcelUpload} />
    </div>
  );
};

export default RenderExcelUploadField;
